import { render, staticRenderFns } from "./HeaderLanguageToggle.vue?vue&type=template&id=0a6edfd6&"
import script from "./HeaderLanguageToggle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HeaderLanguageToggle.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HeaderLanguageToggle.vue?vue&type=style&index=0&id=0a6edfd6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6edfd6')) {
      api.createRecord('0a6edfd6', component.options)
    } else {
      api.reload('0a6edfd6', component.options)
    }
    module.hot.accept("./HeaderLanguageToggle.vue?vue&type=template&id=0a6edfd6&", function () {
      api.rerender('0a6edfd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/HeaderLanguageToggle/HeaderLanguageToggle.vue"
export default component.exports